<div class="ch-breadcrumb">
  <span class="ch-breadcrumb-item" (click)="breadCrumbClick()">Root</span>
  @for (item of breadCrumb; track item) {
    <span class="ch-breadcrumb-item" (click)="breadCrumbClick(item)">&nbsp;/&nbsp;{{item.name}}</span>
  }
</div>
@if (visibleNodes && visibleNodes.length) {
  <div class="select-list">
    @for (node of visibleNodes; track node) {
      <div class="select-list-item clickable" (click)="nodeClicked(node)">
        <i class="fa" [ngClass]="{'fa-folder-o': node.competencyType.toUpperCase() === 'G', 'fa-cube': node.competencyType.toUpperCase() === 'C'}"></i>&nbsp;
        {{node.name}}
        @if (node.competencyType.toUpperCase() === 'C') {
          <span class="item-icon pull-right">&nbsp;<i class="fa fa-chevron-right"></i></span>
        }
      </div>
    }
  </div>
}
